/**
 * Utility functions for calculating colors based on sensor values
 */

/**
 * Calculate color for ORP value
 * @param orpValue - The ORP value in mV
 * @returns Hex color code
 */
export const getOrpColor = (orpValue: number): string => {
  // Check if value is within valid range (0-1400)
  if (orpValue < 0 || orpValue > 1400) {
    return '#ffffff'; // White color for values outside range
  }
  
  // Calculate percentage of the value within range
  const percentage = (orpValue / 1400) * 100;
  
  // Determine color based on percentage
  if (percentage <= 7) {
    return '#990000'; // Deep red
  } else if (percentage <= 14) {
    return '#b30000'; // Red
  } else if (percentage <= 21) {
    return '#cc0000'; // Bright red
  } else if (percentage <= 28) {
    return '#cc3300'; // Red-orange
  } else if (percentage <= 35) {
    return '#cc6600'; // Orange
  } else if (percentage <= 42) {
    return '#cccc00'; // Yellow
  } else if (percentage <= 48) {
    return '#99cc00'; // Yellow-green
  } else if (percentage <= 52) {
    return '#2eb82e'; // Green (ideal value)
  } else if (percentage <= 60) {
    return '#99cc00'; // Back to yellow-green
  } else if (percentage <= 68) {
    return '#cccc00'; // Back to yellow
  } else if (percentage <= 76) {
    return '#cc6600'; // Back to orange
  } else if (percentage <= 84) {
    return '#cc3300'; // Back to red-orange
  } else if (percentage <= 92) {
    return '#cc0000'; // Back to bright red
  } else {
    return '#990000'; // Back to deep red
  }
};

/**
 * Calculate color for pH value
 * @param phValue - The pH value
 * @returns Hex color code
 */
export const getPhColor = (phValue: number): string => {
  // Check if value is within valid range (0-14)
  if (phValue < 0 || phValue > 14) {
    return '#ffffff'; // White color for values outside range
  }
  
  // Calculate percentage of the value within range
  const percentage = (phValue / 14) * 100;
  
  // Determine color based on percentage
  if (percentage <= 7) {
    return '#990000'; // Deep red
  } else if (percentage <= 14) {
    return '#b30000'; // Red
  } else if (percentage <= 21) {
    return '#cc0000'; // Bright red
  } else if (percentage <= 28) {
    return '#cc3300'; // Red-orange
  } else if (percentage <= 35) {
    return '#cc6600'; // Orange
  } else if (percentage <= 42) {
    return '#cccc00'; // Yellow
  } else if (percentage <= 48) {
    return '#99cc00'; // Yellow-green
  } else if (percentage <= 52) {
    return '#2eb82e'; // Green (ideal value)
  } else if (percentage <= 60) {
    return '#99cc00'; // Back to yellow-green
  } else if (percentage <= 68) {
    return '#cccc00'; // Back to yellow
  } else if (percentage <= 76) {
    return '#cc6600'; // Back to orange
  } else if (percentage <= 84) {
    return '#cc3300'; // Back to red-orange
  } else if (percentage <= 92) {
    return '#cc0000'; // Back to bright red
  } else {
    return '#990000'; // Back to deep red
  }
}; 